import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { API_path } from "../service/apiPath";
import axiosInstance from "../service/axios";

const Nav = ({ setSelectedOption, selectedOption, navOptions, hasError }) => {
  const lsUserVO = process.env.REACT_APP_LS_USER_VO;
  const pimsUserVO = JSON.parse(localStorage.getItem(lsUserVO));
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const toggleOption = (option) => {
    console.log("option : ==>",option);
    setIsOpen(false); // Close the menu after selecting an option
    setSelectedOption(option); // Pass the selected option back to the parent component
    localStorage.setItem("navOption", option);
  };

  const handleLogout = async () => {
    try {
      const response = await axiosInstance.get(API_path.logout, {
        params: {
          userName: pimsUserVO.userName,
        },
      });
      const responseData = response.data;
      if (responseData && responseData.status) {
        localStorage.setItem(
          lsUserVO,
          JSON.stringify({
            ...pimsUserVO,
            loginStatus: false,
            isLoggedin: false,
          })
        );
        toast.success(responseData.paramObjectsMap.message);
        navigate("/login");
      } else {
        toast.error(responseData.paramObjectsMap.errorMessage);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="bg-green-200">
      <nav className="container mx-auto flex justify-between items-center p-4">
        <div>
          <a
            className="text-2xl font-black italic hover:text-blue-600"
            href="#"
          >
            {pimsUserVO&&pimsUserVO.pharmacyName ? pimsUserVO.pharmacyName:"PSIMS"}
          </a>
        </div>
        {navOptions.length > 0 && (
          <>
            <div className="lg:hidden">
              <button
                className="text-2xl focus:outline-none"
                onClick={() => setIsOpen(!isOpen)}
              >
                &#9776;
              </button>
            </div>
            <ul
              className={`lg:flex lg:items-center lg:space-x-6 text-lg font-medium ${
                isOpen ? "block" : "hidden"
              } lg:block`}
            >
              {navOptions.map((option) => (
                <li
                  key={option.displayName} // Ensure 'option.id' is unique and present in each option object
                  className={`hover:text-blue-600 ${
                    selectedOption === option.optionVal &&
                    "bg-green-500 p-2 rounded-lg"
                  }`}
                >
                  <a href="#" onClick={() => toggleOption(option.optionVal)}>
                    {option.displayName}
                  </a>
                </li>
              ))}
            </ul>
          </>
        )}
        <button
          onClick={handleLogout}
          className="bg-green-700 px-6 py-2 rounded-full text-white hover:bg-blue-600"
        >
          Logout
        </button>
      </nav>
    </div>
  );
};

export default Nav;
